import { cn } from "@/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";
import { Typography } from "./typography";

export const statusBadgeVariants = cva(
  "inline-flex items-center gap-[6px] justify-center rounded-[10px] px-2 py-1 transition-colors focus:outline-none flex-shrink-0",
  {
    variants: {
      theme: {
        yellow: "bg-colorYellowLight",
        green: "bg-colorGreenLight",
        blue: "bg-colorBlueLight",
        red: "bg-colorRedLight",
        grey: "bg-borderLight",
      },
    },
    defaultVariants: {
      theme: "grey",
    },
  },
);

export interface StatusBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusBadgeVariants> {}

export function StatusBadge({ className, theme = "grey", children, ...props }: StatusBadgeProps) {
  const dotColor = {
    yellow: "bg-colorOrange",
    green: "bg-colorGreenDark",
    blue: "bg-colorBlue",
    red: "bg-colorRedDark",
    grey: "bg-textMuted",
  }[theme ?? "grey"];

  return (
    <div className={cn(statusBadgeVariants({ theme }), className)} {...props}>
      <div className={cn("w-1.5 h-1.5 rounded-full flex-shrink-0", dotColor)} />
      <Typography size="xs" weight={500} asChild>
        <span>{children}</span>
      </Typography>
    </div>
  );
}
